module.exports = __webpack_public_path__ + "static/media/cladding.53f68c9d.jfif";